/*
 * @Author: lubiwei
 * @LastEditors: lubiwei
 * @Description: 投被保人身份认证，华润经代项目接入横琴传世一号时追加的组件
 */
import React, { useEffect, useState } from 'react';
import { Button, Loading, Toast } from 'zarm';
import { fetchClick } from '@/components/Button';
import { getFetchBaseData } from '@/utils/utils';
import { linkFaceAuthModal, queryAuthList } from '@/services';
import { getState, useStore } from '@/store';
import './index.less';

const IdentityVerificationOfInsuredAndHolder = ({
  isVerify = false
}) => {
  const orderDetail = useStore('orderDetail') || {};
  const {
    holder,
    insureList,
    channelCode,
    encryptOrderNo
  } = orderDetail;
  const [participants, setParticipants] = useState([]);

  const getNextStep = async buttonCode => {
    Loading.show();
    const data = getFetchBaseData();
    data.buttonCode = buttonCode;
    Loading.hide();
    fetchClick(data);
  };

  const toPay = () => {
    getNextStep('next_btn_id_verify_hengqin');
  };

  const openFaceAuthModal = ({
    authId,
    authObject,
    authConfigDesc,
    certNo,
    certType,
    name
  }) => {
    const tempKeyOfSessionStorage = `__temp__${Date.now()}`;
    const params = {
      callbackUrl: `${window.location.origin}/faceauth/callback?k=${tempKeyOfSessionStorage}`,
      certiNo: certNo,
      faceAuthMode: 'TENCENT',
      userName: name // certiNo: '310115198603250973',
      // userName: '陆碧蔚'

    };
    linkFaceAuthModal(params).then(res => {
      const {
        code,
        data,
        message
      } = res;

      if (code === '10000') {
        const {
          originalUrl,
          serialNo
        } = data; // 传给字节的人脸识别页面的回调地址如果把backurl带上去的话，接口会报错，所以借用sessionStorage来传回调页面使用的返回认证首页的地址。
        // window.sessionStorage.setItem('__temp__backurl', window.location.href);
        // window.sessionStorage.setItem('__temp__serialNo', serialNo);

        window.sessionStorage.setItem(tempKeyOfSessionStorage, JSON.stringify({
          orderNo: orderDetail.orderNo,
          encryptOrderNo,
          channelCode,
          thirdOrderNo: orderDetail.thirdOrderNo,
          thirdOrderNoType: orderDetail.thirdOrderNoType,
          authId,
          authConfigDesc,
          authObject,
          certNo,
          certType,
          name,
          backUrl: window.location.href,
          serialNo
        }));
        window.location.href = originalUrl;
        return;
      }

      Toast.show(message);
    }).catch(err => {
      Toast.show('服务异常');
    });
  };

  useEffect(() => {
    // 从回调页面（认证结果和签名页）跳转回来，会带上签名的图片的url回来，获取后清除这个临时使用的sessionStorage
    // if (window.sessionStorage.getItem('__temp__sign_url')) {
    //   const signUrl = window.sessionStorage.getItem('__temp__sign_url');
    //   console.log('signUrl: ', signUrl);
    //   // TODO: 这里需要确认签名图片怎么保存
    //   // dispatch('', signUrl);
    //   window.sessionStorage.removeItem('__temp__sign_url');
    // }
    queryAuthList({
      encryptOrderNo,
      channelCode
    }).then(res => {
      console.log('queryAuthList： ');
      console.log(res);
      const {
        success,
        result
      } = res;

      if (success) {
        setParticipants(result.participants);
      }
    });
  }, [encryptOrderNo, channelCode]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "verification-info"
  }, /*#__PURE__*/React.createElement("div", {
    className: "verification-message"
  }, /*#__PURE__*/React.createElement("p", {
    className: "verification-title"
  }, "\u5C0A\u656C\u7684\u5BA2\u6237\uFF0C\u672C\u6B21\u6295\u4FDD\u9700\u8981\u8FDB\u884C\u8EAB\u4EFD\u8BA4\u8BC1\uFF1A"), /*#__PURE__*/React.createElement("div", {
    className: "verification-concent"
  }, /*#__PURE__*/React.createElement("p", null, "1. \u672C\u4EA7\u54C1\u6295\u4FDD\u9700\u8981\u5BF9\u6295\u4FDD\u4EBA\u8FDB\u884C\u5B9E\u540D\u8BA4\u8BC1"), /*#__PURE__*/React.createElement("p", null, "2.\u60A8\u8D2D\u4E70\u672C\u4EA7\u54C1\u7684\u7D2F\u8BA1\u603B\u4FDD\u8D39\u5DF2\u8D85\u8FC720\u4E07,\u6309\u76D1\u7BA1\u8981\u6C42\uFF0C\u9700\u8981\u63D0\u4F9B\u6295\u4FDD\u4EBA\uFF0C\u88AB\u4FDD\u4EBA\uFF0C\u6307\u5B9A\u53D7\u76CA\u4EBA\u8BC1\u4EF6\u5F71\u50CF"), /*#__PURE__*/React.createElement("p", null, "3.\u672C\u4EA7\u54C1\u975E\u672C\u4EBA\u6295\u4FDD\u4E14\u5E26\u8EAB\u6545\u8D23\u4EFB\uFF0C\u9700\u5BF9\u6295\u4FDD\u4EBA\u3001\u88AB\u4FDD\u4EBA(\u6210\u4EBA)\u7684\u6295\u4FDD\u610F\u613F\u8FDB\u884C\u7B7E\u5B57\u786E\u8BA4\u3002"))), participants === null || participants === void 0 ? void 0 : participants.map((participant, index) => /*#__PURE__*/React.createElement("div", {
    className: "personnel-info",
    key: `participant_${index}`
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", {
    className: "personnel-name"
  }, participant.name), /*#__PURE__*/React.createElement("span", {
    className: "personnel-type"
  }, participant.authObjectName), /*#__PURE__*/React.createElement("p", {
    className: "personnel-num"
  }, participant.certNo)), /*#__PURE__*/React.createElement("div", null, participant.status !== 'authSuccess' ? /*#__PURE__*/React.createElement(Button, {
    theme: "primary",
    size: "xs",
    className: "verification-false",
    onClick: () => {
      openFaceAuthModal(participant);
    }
  }, "\u8BF7\u8BA4\u8BC1") : /*#__PURE__*/React.createElement("p", {
    className: "verification-true"
  }, "\u5DF2\u5B8C\u6210")))), /*#__PURE__*/React.createElement("div", {
    className: "pay-footer"
  }, /*#__PURE__*/React.createElement(Button, {
    theme: "primary",
    block: true,
    onClick: toPay
  }, "\u652F\u4ED8\u4FDD\u8D39"))));
};

export default IdentityVerificationOfInsuredAndHolder;